import React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { Column, Text } from './MarketItem';
import KyeongBuLineMarketsImg from 'assets/images/market/kyeong_bu_line_markets.png';
import ImagesZoom from 'components/pages/community/ImagesZoom';

function PrepareView() {
   const PREPARE_TEXT = '고속터미널(경부선) 꽃 도매시장은\n입점 준비중이에요.';
   const IMG_TITLE = '경부선 꽃 도매상가';
   const [isOpenZoom, setOpenZoom] = useState(false);
   const openZoom = () => setOpenZoom(true);
   const closeZoom = () => setOpenZoom(false);
   return (
      <PrepareViewWrap>
         <Text>{PREPARE_TEXT}</Text>
         <MapImage src={KyeongBuLineMarketsImg} alt={IMG_TITLE} onClick={openZoom} />
         {isOpenZoom && <ImagesZoom images={[KyeongBuLineMarketsImg]} onClose={closeZoom} />}
      </PrepareViewWrap>
   );
}

export default PrepareView;

const PrepareViewWrap = styled(Column)`
   padding-top: 64px;
   align-items: center;
   justify-content: center;

   ${Text} {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      white-space: pre-wrap;
      margin-bottom: 40px;
   }
`;

const MapImage = styled.img`
   cursor: pointer;
   width: 100%;
   margin: 0px 6px;
`;
